module.exports = __webpack_public_path__ + "fonts/Inter-400-cyrillic23.de93fdc.woff2";